<section class="shift-otp-align">
    <form>
      <div class="form-group required col-12 mt-3">
        <label class="control-label" for="password1">Enter Password</label>
        <input type="password" id="password1" [(ngModel)]="newPassword"  class="form-control" (blur)="SelectNewPassword()" [ngClass]="{'is-invalid':statusText1}"
               [ngModelOptions]="{standalone: true}" required>
        <div id="statusText1" class="invalid-feedback d-block mb-2" [hidden]="!statusText1">{{statusText1}}</div>
      </div>
      <div class="form-group required col-12">
        <label class="control-label"  for="rePassword">Re-enter Password</label>
        <input type="password" id="rePassword" [(ngModel)]="confirmPassword" class="form-control" (blur)="SelectConfirmPassword()" [ngClass]="{'is-invalid':(statusText2 || statusText)}"
               [ngModelOptions]="{standalone: true}" required>
        <div id="statusText2"class="invalid-feedback d-block mb-2" [hidden]="!statusText2">{{statusText2}}</div>
        <div id="statusText"class="invalid-feedback d-block mb-2" [hidden]="!statusText">{{statusText}}</div>
      </div>
      <div class="row align-items-center mt-3" style="
    padding-left: 15px;
    padding-right: 15px;">
        <div class="col-12">
          <button class="btn btn-orange-prime mb-3 btn-block" (click)="submitResetPassword()">Reset</button>
        </div>
      </div>
    </form>
</section>
